import { render, staticRenderFns } from "./Tv2.vue?vue&type=template&id=5ac22a44&"
import script from "./Tv2.vue?vue&type=script&lang=js&"
export * from "./Tv2.vue?vue&type=script&lang=js&"
import style0 from "./Tv2.vue?vue&type=style&index=0&id=5ac22a44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports